import React from "react";
import Navmenu from "./Navmenu";
import { menuItems } from "@/constant/data";
import useSemiDark from "@/hooks/useSemiDark";
import BrandWordmark from "@/components/ui/BrandWordmark";
import Icon from "@/components/ui/Icon";
import { useSelector, useDispatch } from "react-redux";
import { handleSidebarCollapsed } from "@/store/layout";

const Sidebar = () => {
  const [isSemiDark] = useSemiDark();
  const isCollapsed = useSelector((s) => Boolean(s.layout?.isCollapsed));
  const dispatch = useDispatch();

  return (
    <div className={isSemiDark ? "dark" : ""}>
      <aside
        className={`font-jakarta sidebar-wrapper fixed inset-y-0 left-0 z-[1000] hidden flex-col border-r border-stone-200/90 bg-stone-50/95 shadow-sm transition-[width] duration-200 ease-out dark:border-slate-800 dark:bg-slate-950/95 md:flex ${
          isCollapsed ? "w-16" : "w-52"
        }`}
      >
        <div
          className={`relative shrink-0 border-b border-stone-200/80 pb-4 pt-5 dark:border-slate-800 ${
            isCollapsed ? "px-1.5" : "px-3"
          }`}
        >
          <div
            className="absolute left-0 top-7 h-9 w-0.5 rounded-r-full bg-teal-500/90"
            aria-hidden
          />
          <BrandWordmark variant="sidebar" collapsed={isCollapsed} />
        </div>

        <Navmenu
          menus={menuItems}
          className="min-h-0 flex-1 pt-3"
          collapsed={isCollapsed}
        />

        <div className="shrink-0 border-t border-stone-200/80 p-1.5 dark:border-slate-800">
          <button
            type="button"
            onClick={() => dispatch(handleSidebarCollapsed(!isCollapsed))}
            className="flex w-full items-center justify-center gap-2 rounded-lg py-2 text-slate-600 transition hover:bg-stone-200/80 dark:text-slate-400 dark:hover:bg-slate-800"
            aria-expanded={!isCollapsed}
            aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <Icon
              icon={
                isCollapsed
                  ? "heroicons-outline:chevron-double-right"
                  : "heroicons-outline:chevron-double-left"
              }
              className="text-lg"
            />
            {!isCollapsed ? (
              <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                Collapse
              </span>
            ) : null}
          </button>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
